import { render, staticRenderFns } from "./FormProducto.vue?vue&type=template&id=33fc6d42&scoped=true"
import script from "./FormProducto.vue?vue&type=script&lang=js"
export * from "./FormProducto.vue?vue&type=script&lang=js"
import style0 from "./FormProducto.vue?vue&type=style&index=0&id=33fc6d42&prod&scoped=true&lang=css"
import style1 from "./FormProducto.vue?vue&type=style&index=1&id=33fc6d42&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fc6d42",
  null
  
)

export default component.exports